import { useNavigate } from "react-router-dom";
import { Text } from "../../../../components/common/typography";
import { Button } from "../../../../components/common/button";
import { AppRoutes } from "../../../../common/routes/app_routes";

interface ProductNotFoundProps {
  error?: Error | null;
}

export function ProductNotFound({ error }: ProductNotFoundProps) {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="bg-bgDefault rounded-xl p-8 text-center">
        <Text variant="body" className="mb-4 text-accentError">
          {error?.message || "Product not found"}
        </Text>
        <Button variant="primary" onClick={() => navigate(AppRoutes.PRODUCTS)}>
          Back to Products
        </Button>
      </div>
    </div>
  );
}
